import * as React from 'react';
import { countryOptions } from './AddressFieldsHelpers';
import { SelectField } from './select-field';

const CountrySelectField = React.forwardRef(
  //@ts-ignore
  ({ before, afterField, after, wrapperElement, id, label, name, text, help, options: _options }, ref) => {
    return (
      <SelectField
        ref={ref}
        // @ts-ignore */
        id={id}
        // @ts-ignore */
        name={name}
        /*
        // @ts-ignore */
        required
        options={countryOptions}
        {...{ before, afterField, after, id, label, name, text, help, wrapperElement }}
      />
    );
  }
);

export default CountrySelectField;
